export default defineAppConfig({
  ui: {
    colors: {
      primary: "mundojoven",
      secondary: "cyan",
      neutral: "slate",
      info: "teal",
      warning: "amber"
    }
  },
  channel_id: 7000,
})